exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{\r\n  background-color:#dfe3ea;\r\n}\r\n\r\n\r\n.icontext\r\n{\r\n  font-size:10px;\r\n  margin-top:0px;\r\n  border-right:1px solid black;\r\n  padding:10px;\r\n  overflow:hidden;\r\n\r\n\r\n\r\n}\r\n#strategy\r\n{\r\n  border:none;\r\n}\r\n.Gamified\r\n{\r\n  font-size:15px;\r\n  font-weight:bold;\r\n}\r\n\r\n.moduleimg\r\n{\r\n  height:50px;\r\n  width:50px;\r\n}\r\n.moduleimg:hover\r\n{\r\n  height:50px;\r\n  width:50px;\r\n  transform:scale(1.5);\r\n  padding-right:5px;\r\n}\r\n.form-control-feedback\r\n{\r\n  margin-top:-5px;\r\n}\r\n.lastmost{\r\nborder:none;\r\n\r\n}\r\n.panel-info>.panel-heading\r\n{\r\n  background:#78d5e3\r\n}\r\n.margin {\r\n  margin-left:-10px;\r\n}\r\n\r\n@media screen and (max-device-width : 320px)\r\n{\r\ndiv[class*=\"col-\"]>footer.icontext\r\n{\r\n  font-size:10px;\r\n}\r\n}\r\n\r\n.rating {\r\ncolor:#883867;\r\n}\r\n.btn-sticker-theme {\r\nbackground:#883867;\r\ncolor:white;\r\n}\r\n\r\n.panel-info{\r\nborder-color:#78D5E3;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/dashboard/dashboard.component.css
// module id = ../../../../../src/app/dashboard/dashboard.component.css
// module chunks = 2